import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Accreditation() { 
  useEffect(() => {
    document.title = 'Accreditation -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Accreditation</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Accreditation</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                  <p> The School is affiliated to the Council For The Indian School Certificate Examination, New Delhi and conducts public examinations in Std. 10 and Std. 12:</p>
                  <ul className="mainlist">
                    <li>Indian Certificate of Secondary Education Examination (ICSE): a two – year course covered in Classes 9 and 10.</li>
                    <li>The Indian School Certificate (ISC): a two – year syllabus covered in Classes 11 and 12</li>
                 </ul>

              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Accreditation;
